var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Tooltip } from '@mui/material';
const MidmarkOverflowTooltip = (_a) => {
    var _b, _c;
    var { elementRef, title } = _a, props = __rest(_a, ["elementRef", "title"]);
    const [overflown, setOverflown] = React.useState(false);
    const [changed, setChanged] = React.useState(false);
    React.useEffect(() => {
        let timeoutId = null;
        const onResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => setChanged((change) => !change), 150);
        };
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);
    React.useEffect(() => {
        if (elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) {
            setOverflown(isOverflown(elementRef.current));
        }
    }, [
        elementRef,
        (_b = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) === null || _b === void 0 ? void 0 : _b.scrollWidth,
        (_c = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) === null || _c === void 0 ? void 0 : _c.clientWidth,
        changed,
    ]);
    return _jsx(Tooltip, Object.assign({ title: overflown ? title : '' }, props));
};
function isOverflown(element) {
    return (element.scrollHeight > element.clientHeight ||
        element.scrollWidth > element.clientWidth);
}
export default MidmarkOverflowTooltip;
